module.exports = __webpack_public_path__ + "508d36f92a7ac10c95c5432bd7f57124.pdf";